export default __webpack_public_path__ + "static/media/icon_marine world.13cb2ff7.png";